<div #menuContainer class="ax-base-context-menu__container" [tabIndex]="1">
    <ng-template ax-context-menu></ng-template>
</div>
